import React, { useRef, useState } from "react";
import * as Fa from "react-icons/fa";
import { FileUpload } from "primereact/fileupload";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { toast } from "react-toastify";
import { fetchData, postData } from "../../../Services/GlobalService";
import { GetDateFormat } from "../../../Services/GlobalFunction/GetDateFormat";
import { ExcelUpload } from "../../../Services/GlobalFunction/Excel";
import { downloadExcel, downloadExcelDateFormat } from "../../../Services/GlobalFunction/DownLoadExcel";
import { format } from "date-fns";
import Loader from "../../../Components/Loader";

/* ============================================================
   COMPONENT
============================================================ */
const CoreNonCoreTownMapping: React.FC = () => {
  const UserId = localStorage.getItem("UserId")?.toString();
  let getformat = GetDateFormat();

  const BaseUrl = "SIPReport/CoreNonCoreTownMapping";
  const Endpoint = {
    GetDistributorList: "GetDistributorList",
    DownloadMapping: "DownloadMapping",
    GetTowns: "GetTowns",
    SaveMapping: "SaveMapping",
    MapAllAsCore: "MapAllAsCore",
    MapAllAsNonCore: "MapAllAsNonCore",
  };

  const fileUploadRef = useRef<FileUpload>(null);

  /* ── State ── */
  const [selectedMonth, setSelectedMonth] = useState<Date | null>(null);
  const [selectedDistributor, setSelectedDistributor] = useState<any>(null);
  const [distributorList, setDistributorList] = useState<any[]>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [errorxlsbtn, setErrorxlsbtn] = useState<boolean>(false);
  const [errorxlsData, setErrorxlsData] = useState<any[]>([]);
  const [downloadMappingLoading, setDownloadMappingLoading] = useState<boolean>(false);
  const [getTownsLoading, setGetTownsLoading] = useState<boolean>(false);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);
  const [mapAllCoreLoading, setMapAllCoreLoading] = useState<boolean>(false);
  const [mapAllNonCoreLoading, setMapAllNonCoreLoading] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});

  /* ── Validation ── */
  const validateFilters = () => {
    const newErrors: any = {};
    if (!selectedMonth) newErrors.selectedMonth = "Please select a Month";
    if (!selectedDistributor) newErrors.selectedDistributor = "Please select a Distributor";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ── Download Mapping ── */
  const handleDownloadMapping = async () => {
    setSubmitted(true);
    if (!validateFilters()) return;
    setDownloadMappingLoading(true);
    try {
      const res = await fetchData(
        BaseUrl,
        Endpoint.DownloadMapping,
        `UserId=${UserId}&Month=${format(selectedMonth!, "MM/yyyy")}&DistributorId=${selectedDistributor?.value}`
      );
      if (res?.Data?.length > 0) {
        downloadExcelDateFormat(
          res.Data,
          `Core_NonCore_Town_Mapping_${getformat}.xlsx`
        );
      } else {
        toast.error("No Data Found");
      }
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message ?? "Download failed");
    } finally {
      setDownloadMappingLoading(false);
    }
  };

  /* ── Get Towns ── */
  const handleGetTowns = async () => {
    setSubmitted(true);
    if (!validateFilters()) return;
    setGetTownsLoading(true);
    try {
      const res = await fetchData(
        BaseUrl,
        Endpoint.GetTowns,
        `UserId=${UserId}&Month=${format(selectedMonth!, "MM/yyyy")}&DistributorId=${selectedDistributor?.value}`
      );
      console.log("[CoreNonCoreTownMapping] Towns data", res?.Data);
      // Wire up grid or state population here
      if (!res?.Data?.length) toast.warn("No towns found.");
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message ?? "Failed to get towns");
    } finally {
      setGetTownsLoading(false);
    }
  };

  /* ── Save ── */
  const handleSave = async () => {
    setSaveLoading(true);
    try {
      const payload = {
        UserId,
        Month: selectedMonth ? format(selectedMonth, "MM/yyyy") : null,
        DistributorId: selectedDistributor?.value,
      };
      console.log("[CoreNonCoreTownMapping] Save payload", payload);
      // const res = await postData(BaseUrl, Endpoint.SaveMapping, payload);
      // toast.success(res.Message);
      toast.success("Mapping saved successfully.");
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message ?? "Save failed");
    } finally {
      setSaveLoading(false);
    }
  };

  /* ── Map All As Core ── */
  const handleMapAllAsCore = async () => {
    setMapAllCoreLoading(true);
    try {
      const payload = {
        UserId,
        Month: selectedMonth ? format(selectedMonth, "MM/yyyy") : null,
        DistributorId: selectedDistributor?.value,
        MappingType: "CORE",
      };
      console.log("[CoreNonCoreTownMapping] Map all as core payload", payload);
      // const res = await postData(BaseUrl, Endpoint.MapAllAsCore, payload);
      // toast.success(res.Message);
      toast.success("All towns mapped as Core.");
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message ?? "Failed to map as core");
    } finally {
      setMapAllCoreLoading(false);
    }
  };

  /* ── Map All As Non Core ── */
  const handleMapAllAsNonCore = async () => {
    setMapAllNonCoreLoading(true);
    try {
      const payload = {
        UserId,
        Month: selectedMonth ? format(selectedMonth, "MM/yyyy") : null,
        DistributorId: selectedDistributor?.value,
        MappingType: "NON_CORE",
      };
      console.log("[CoreNonCoreTownMapping] Map all as non-core payload", payload);
      // const res = await postData(BaseUrl, Endpoint.MapAllAsNonCore, payload);
      // toast.success(res.Message);
      toast.success("All towns mapped as Non Core.");
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message ?? "Failed to map as non-core");
    } finally {
      setMapAllNonCoreLoading(false);
    }
  };

  /* ── File Upload ── */
  const handleFileUpload = async (event: any) => {
    try {
      setLoader(true);
      const res = await ExcelUpload(
        "CORE_NON_CORE_TOWN_MAPPING",
        `Month=${selectedMonth ? format(selectedMonth, "MM/yyyy") : ""}&DistributorId=${selectedDistributor?.value ?? ""}`,
        event.files[0],
        "Excel"
      );
      console.log(res, "CoreNonCoreTownMappingUpload");
      if (res.Status === "Success") {
        toast.success(res.Message);
        fileUploadRef.current?.clear();
        setErrorxlsbtn(false);
      } else if (res.Status === "ErrorFR") {
        toast.warn(res.Message);
        fileUploadRef.current?.clear();
        setErrorxlsbtn(false);
      } else if (res.Status === "Error") {
        toast.warn(res.Message);
        setErrorxlsbtn(true);
        setErrorxlsData(res.Data);
      }
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message ?? "Upload failed");
      fileUploadRef.current?.clear();
      setErrorxlsbtn(false);
    } finally {
      setLoader(false);
    }
  };

  /* ── Error Excel Download ── */
  const excelErrorDownload = () => {
    setLoader(true);
    downloadExcel(errorxlsData, "Core_NonCore_Town_Mapping_Error.xlsx");
    setLoader(false);
  };


  if (loader) return <Loader />;

  return (
    <main>
      <div className="col-12 mb-5">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mx-0">
              <li className="breadcrumb-item">DB SIP</li>
              <li className="breadcrumb-item active" aria-current="page">
                Core Non Core Town Mapping
              </li>
            </ol>
          </nav>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <h3 className="py-2">Core Non Core Town Mapping</h3>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="text-end">
              <button
                type="button"
                className="btn anime-btn me-2"
                onClick={handleMapAllAsCore}
                disabled={mapAllCoreLoading}
              >
                {mapAllCoreLoading ? (
                  <>
                    Loading...{" "}
                    <span
                      className="spinner-border spinner-border-sm ms-1"
                      role="status"
                      aria-hidden="true"
                    />
                  </>
                ) : (
                  "Map all as core"
                )}
              </button>
              <button
                type="button"
                className="btn anime-secondary-btn me-2"
                onClick={handleMapAllAsNonCore}
                disabled={mapAllNonCoreLoading}
              >
                {mapAllNonCoreLoading ? (
                  <>
                    Loading...{" "}
                    <span
                      className="spinner-border spinner-border-sm ms-1"
                      role="status"
                      aria-hidden="true"
                    />
                  </>
                ) : (
                  "Map all as non core"
                )}
              </button>
              <button
                type="button"
                className="btn anime-btn"
                onClick={handleSave}
                disabled={saveLoading}
              >
                {saveLoading ? (
                  <>
                    Saving...{" "}
                    <span
                      className="spinner-border spinner-border-sm ms-1"
                      role="status"
                      aria-hidden="true"
                    />
                  </>
                ) : (
                  <>
                    Save
                  </>
                )}
              </button>

              {errorxlsbtn && (
                <button
                  type="button"
                  className="btn anime-red-btn ms-2"
                  onClick={excelErrorDownload}
                >
                  Error Excel File <Fa.FaDownload className="ms-2" />
                </button>
              )}
            </div>
          </div>
        </div>

        <section className="sales-box mb-3">
          <div className="row d-flex justify-content-end align-items-end">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="d-block">
                <label className="form-label">Month</label>
                <Calendar
                  value={selectedMonth}
                  onChange={(e) => {
                    setSelectedMonth(e.value as Date);
                    setErrors({ ...errors, selectedMonth: null });
                  }}
                  view="month"
                  dateFormat="mm/yy"
                  showIcon
                  placeholder="Select Month"
                  className={
                    submitted && errors.selectedMonth
                      ? "p-invalid w-100"
                      : "w-100"
                  }
                />
                {submitted && errors.selectedMonth && (
                  <small className="p-error">{errors.selectedMonth}</small>
                )}
              </div>
            </div>
            <div className="col-lg-5 col-md-6 col-sm-12">
              <div className="d-block">
                <label className="form-label">Distributor</label>
                <Dropdown
                  value={selectedDistributor}
                  onChange={(e) => {
                    setSelectedDistributor(e.value);
                    setErrors({ ...errors, selectedDistributor: null });
                  }}
                  options={distributorList}
                  optionLabel="label"
                  placeholder="Select Distributor"
                  className={
                    submitted && errors.selectedDistributor
                      ? "p-invalid w-100"
                      : "w-100"
                  }
                />
                {submitted && errors.selectedDistributor && (
                  <small className="p-error">{errors.selectedDistributor}</small>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="text-end">
                <button
                  type="button"
                  className="btn anime-secondary-btn me-2"
                  onClick={handleDownloadMapping}
                  disabled={downloadMappingLoading}
                >
                  {downloadMappingLoading ? (
                    <>
                      Loading...{" "}
                      <span
                        className="spinner-border spinner-border-sm ms-1"
                        role="status"
                        aria-hidden="true"
                      />
                    </>
                  ) : (
                    <>
                      Download Mapping <Fa.FaDownload className="ms-2" />
                    </>
                  )}
                </button>
                <button
                  type="button"
                  className="btn anime-btn"
                  onClick={handleGetTowns}
                  disabled={getTownsLoading}
                >
                  {getTownsLoading ? (
                    <>
                      Loading...{" "}
                      <span
                        className="spinner-border spinner-border-sm ms-1"
                        role="status"
                        aria-hidden="true"
                      />
                    </>
                  ) : (
                    "Get Towns"
                  )}
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="sales-box">
          <div className="row d-flex justify-content-end align-items-end">
            <div className="col-lg-7 col-md-7 col-sm-12">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-6 col-md-3 col-sm-12">
                  <h6>Upload File</h6>
                </div>
                <div className="col-lg-6 col-md-3 col-sm-12">
                  <div className="text-end">
                    {errorxlsbtn && (
                      <button
                        type="button"
                        className="btn anime-red-btn"
                        onClick={excelErrorDownload}
                      >
                        Error Excel File <Fa.FaDownload className="ms-2" />
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                  <div className="UploadSection">
                    <div className="conText">
                      <Fa.FaInfoCircle className="icon" /> Upload a .xlsx/.csv file only
                    </div>
                    <FileUpload
                      ref={fileUploadRef}
                      className="clearfix nTopMargin"
                      name="demo[]"
                      accept=".xlsx, .xls, .csv"
                      emptyTemplate={
                        <p className="m-0">Drag and drop files here to upload.</p>
                      }
                      customUpload
                      uploadHandler={handleFileUpload}
                      onClear={() => setErrorxlsbtn(false)}
                      onRemove={() => setErrorxlsbtn(false)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-12">
              <div className="text-end">
                <img src={require("../../../Assets/Images/File_Upload.png")} className="File_Upload_Img drop-right" alt="" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default CoreNonCoreTownMapping;